import { Injectable } from "@angular/core";
import { Device } from "@nms-ng2/app/modules/device/device-backup/device-backup.models";

/**
 * Serviço responsável por realizar validações para equipamentos na modal de links.
 */
@Injectable({
    providedIn: "root"
})
export class LinkDeviceValidationService {

    getEndsError(aEndDevice: Device, zEndDevice: Device): string {
        let errorMessageKey = ""

        if (!aEndDevice && !zEndDevice) {
            errorMessageKey = "links.modal.devices.must.be.selected";
        } else if (!aEndDevice) {
            errorMessageKey = "links.modal.devices.aEnd.must.be.selected";
        } else if (!zEndDevice) {
            errorMessageKey = "links.modal.devices.zEnd.must.be.selected";
        }

        return errorMessageKey;
    }
}
